import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { useApi } from './hooks/useApi';
import { ApiError, api } from './lib/api';
import { AdminLessonPage } from './pages/AdminLesson';
import { AdminSchedulePage } from './pages/AdminSchedule';
import { LoginPage } from './pages/Login';
import { TasksPage } from './pages/Tasks';
import { TodayPage } from './pages/Today';
import { WeekPage } from './pages/Week';

export function App() {
  const me = useApi(() => api.me(), []);

  if (me.loading) {
    return <div className="boot">Laddar…</div>;
  }

  // 401 betyder utloggad, inte fel. Allt annat är ett riktigt fel.
  if (me.error instanceof ApiError && me.error.status === 401) {
    return <LoginPage />;
  }

  if (me.error) {
    return (
      <div className="boot">
        <p>Kunde inte nå servern.</p>
        <button type="button" className="button button--ghost" onClick={me.reload}>
          Försök igen
        </button>
      </div>
    );
  }

  const isTeacher = me.data?.memberships.some((m) => m.role === 'teacher') ?? false;

  return (
    <AppShell me={me.data}>
      <Routes>
        <Route path="/" element={<TodayPage />} />
        <Route path="/vecka" element={<WeekPage />} />
        <Route path="/uppgifter" element={<TasksPage />} />
        {isTeacher && <Route path="/admin" element={<AdminSchedulePage />} />}
        {isTeacher && <Route path="/admin/lektion/:id" element={<AdminLessonPage />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
